import { atom } from 'jotai';

export const scheduleWelcomeOpenAtom = atom<boolean>(false);
